"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { generateCalendar } from "@/helpers/calendar/calendar.helpers";
import CommonCalendarDay from "./CommonCalendarDay";
const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
export default function CommonCalendar(t0) {
  const $ = _c(51);
  const {
    initialMonth,
    initialYear,
    minTimestamp,
    maxTimestamp,
    selectedTimestamp,
    setSelectedTimestamp
  } = t0;
  let t1;
  if ($[0] !== initialMonth || $[1] !== selectedTimestamp) {
    t1 = () => {
      if (selectedTimestamp) {
        return new Date(selectedTimestamp).getMonth();
      }
      return initialMonth;
    };
    $[0] = initialMonth;
    $[1] = selectedTimestamp;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [month, setMonth] = useState(t1);
  let t2;
  if ($[3] !== initialYear || $[4] !== selectedTimestamp) {
    t2 = () => {
      if (selectedTimestamp) {
        return new Date(selectedTimestamp).getFullYear();
      }
      return initialYear;
    };
    $[3] = initialYear;
    $[4] = selectedTimestamp;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const [year, setYear] = useState(t2);
  let t3;
  if ($[6] !== month || $[7] !== year) {
    t3 = generateCalendar({
      month,
      year
    });
    $[6] = month;
    $[7] = year;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const [days, setDays] = useState(t3);
  let t4;
  let t5;
  if ($[9] !== month || $[10] !== year) {
    t4 = () => setDays(generateCalendar({
      month,
      year
    }));
    t5 = [month, year];
    $[9] = month;
    $[10] = year;
    $[11] = t4;
    $[12] = t5;
  } else {
    t4 = $[11];
    t5 = $[12];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[13] !== selectedTimestamp) {
    t6 = () => {
      if (selectedTimestamp) {
        const date = new Date(selectedTimestamp);
        setMonth(date.getMonth());
        setYear(date.getFullYear());
      }
    };
    t7 = [selectedTimestamp];
    $[13] = selectedTimestamp;
    $[14] = t6;
    $[15] = t7;
  } else {
    t6 = $[14];
    t7 = $[15];
  }
  useEffect(t6, t7);
  let t8;
  if ($[16] !== month || $[17] !== year) {
    t8 = () => {
      if (month === 11) {
        setMonth(0);
        setYear(year + 1);
      } else {
        setMonth(month + 1);
      }
    };
    $[16] = month;
    $[17] = year;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const setNextMonth = t8;
  let t9;
  if ($[19] !== month || $[20] !== year) {
    t9 = () => {
      if (month === 0) {
        setMonth(11);
        setYear(year - 1);
      } else {
        setMonth(month - 1);
      }
    };
    $[19] = month;
    $[20] = year;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const setPreviousMonth = t9;
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <svg className="tw-h-6 tw-w-6" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== setPreviousMonth) {
    t11 = <button onClick={setPreviousMonth} type="button" aria-label="Previous month" className={"tw-bg-transparent tw-border tw-border-transparent tw-border-solid tw-absolute \n              tw-left-1.5 tw-top-1.5 tw-flex tw-items-center tw-justify-center tw-p-2 tw-text-iron-300 hover:tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out"}>{t10}</button>;
    $[23] = setPreviousMonth;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <svg className="tw-h-6 tw-w-6" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== setNextMonth) {
    t13 = <button onClick={setNextMonth} type="button" aria-label="Next month" className="tw-bg-transparent tw-border tw-border-transparent tw-border-solid tw-absolute tw-right-1.5 tw-top-1.5 tw-flex tw-items-center tw-justify-center tw-p-2 tw-text-iron-300 hover:tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out">{t12}</button>;
    $[26] = setNextMonth;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  const t14 = MONTHS[month];
  let t15;
  if ($[28] !== t14) {
    t15 = <p className="tw-text-base tw-font-medium tw-text-iron-50">{t14}</p>;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <div className="tw-mt-4 tw-px-3 tw-grid tw-grid-cols-7 tw-text-sm tw-leading-6 tw-font-medium tw-text-iron-500"><div>Mo</div><div>Tu</div><div>We</div><div>Th</div><div>Fr</div><div>Sa</div><div>Su</div></div>;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== days || $[32] !== maxTimestamp || $[33] !== minTimestamp || $[34] !== selectedTimestamp || $[35] !== setSelectedTimestamp) {
    let t18;
    if ($[37] !== maxTimestamp || $[38] !== minTimestamp || $[39] !== selectedTimestamp || $[40] !== setSelectedTimestamp) {
      t18 = day => <CommonCalendarDay key={`calendar-${day.startTimestamp}`} day={day} minTimestamp={minTimestamp} maxTimestamp={maxTimestamp} selectedTimestamp={selectedTimestamp} setSelectedTimestamp={setSelectedTimestamp} />;
      $[37] = maxTimestamp;
      $[38] = minTimestamp;
      $[39] = selectedTimestamp;
      $[40] = setSelectedTimestamp;
      $[41] = t18;
    } else {
      t18 = $[41];
    }
    t17 = days.map(t18);
    $[31] = days;
    $[32] = maxTimestamp;
    $[33] = minTimestamp;
    $[34] = selectedTimestamp;
    $[35] = setSelectedTimestamp;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  let t18;
  if ($[42] !== t17) {
    t18 = <div className="tw-isolate tw-mt-2 tw-grid tw-grid-cols-7 tw-gap-1.5 tw-px-4">{t17}</div>;
    $[42] = t17;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t15 || $[45] !== t18) {
    t19 = <section className="tw-text-center">{t15}{t16}{t18}</section>;
    $[44] = t15;
    $[45] = t18;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== t11 || $[48] !== t13 || $[49] !== t19) {
    t20 = <div className="tw-py-3 tw-relative tw-rounded-lg tw-bg-iron-800/60 tw-shadow-md tw-ring-1 tw-ring-iron-700/50 tw-ring-inset">{t11}{t13}{t19}</div>;
    $[47] = t11;
    $[48] = t13;
    $[49] = t19;
    $[50] = t20;
  } else {
    t20 = $[50];
  }
  return t20;
}